import { NavLink, Outlet } from 'react-router-dom'
import { AppHeader } from '@/components/layout/AppHeader'

const TABS = [
  { to: '/admin', label: 'Overview', end: true },
  { to: '/admin/users', label: 'Users', end: false },
  { to: '/admin/projects', label: 'Projects', end: false },
  { to: '/admin/settings', label: 'Settings', end: false },
]

export function AdminLayout() {
  return (
    <div className="min-h-screen bg-slate-50">
      <AppHeader />
      <nav className="border-b border-slate-200 bg-white px-4">
        <div className="flex gap-1">
          {TABS.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              end={tab.end}
              className={({ isActive }) =>
                `border-b-2 px-3 py-3 text-sm font-medium ${
                  isActive
                    ? 'border-primary text-primary'
                    : 'border-transparent text-slate-500 hover:text-slate-700'
                }`
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </div>
      </nav>
      <main className="p-4 sm:p-6">
        <Outlet />
      </main>
    </div>
  )
}
